const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
console.log("API Base URL:", API_BASE_URL);

export const downloadHeatmap = (downloadItems) => {
  return fetch(`${API_BASE_URL}/api/download/heatmap`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      // Include other headers if necessary
    },
    body: JSON.stringify(downloadItems),
  }).then((response) => {
    if (response.ok) {
      return response.blob().then((blob) => ({
        data: blob,
        headers: {
          "content-disposition": response.headers.get("Content-Disposition"),
        },
      }));
    } else {
      throw new Error("Network response was not ok");
    }
  });
};
